import * as actions from './session.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store} from '@ngrx/store';
import { SessionModel } from '@smarttask-common/src/lib/models/Internal/SessionModel';


export const sessionAdapter = createEntityAdapter<SessionModel>({
  selectId: x => x.session_id
});
export interface SessionState extends EntityState<SessionModel>{
  selected_session_id: string
};

export const initialState: SessionState = sessionAdapter.getInitialState({
  selected_session_id: undefined,
}); 

export function SessionReducers(
  state: SessionState = initialState,
  action: actions.SessionActions
){
  switch(action.type){
    case actions.SessionActionTypes.UPDATE_SELECTED_ID:
      state = {...state, selected_session_id: action.selected_session_id};
      //console.log(state);
      return state;

    case actions.SessionActionTypes.ADD_SESSION: 
      return sessionAdapter.addOne(action.session, {...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.ADD_SESSIONS:
      return sessionAdapter.addMany(action.sessions,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.UPSERT_SESSION:
      return sessionAdapter.upsertOne(action.session,{...state,selected_session_id: state.selected_session_id});
      
    case actions.SessionActionTypes.UPSERT_SESSIONS:
      return sessionAdapter.upsertMany(action.sessions,{...state,selected_session_id: state.selected_session_id});
  
    case actions.SessionActionTypes.UPDATE_SESSION:
      return sessionAdapter.updateOne(action.session,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.UPDATE_SESSIONS:
      return sessionAdapter.updateMany(action.sessions,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.DELETE_SESSION:
      // if(state.selected_session_id == action.id){
      //   state.selected_session_id = undefined;
      // }
      return sessionAdapter.removeOne(action.id,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.DELETE_SESSIONS:
      // if(action.ids.indexOf(state.selected_session_id) > -1){
      //   state.selected_session_id = undefined;
      // }
      return sessionAdapter.removeMany(action.ids,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.DELETE_ALL_SESSIONS:
      return sessionAdapter.removeMany(action.ids,{...state,selected_session_id: state.selected_session_id});

    case actions.SessionActionTypes.DELETE_ALL:
      state.selected_session_id = undefined;
      return sessionAdapter.removeAll(state);

    default:
      return state;
  }
}

export const getSessionState = createFeatureSelector<SessionState>('session');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = sessionAdapter.getSelectors(getSessionState);

const getSelectedSessionIdState = (state: SessionState) => { 
  return state.selected_session_id
};
export const getSelectedSessionId = createSelector(getSessionState, getSelectedSessionIdState);

export const getSelectedSession = createSelector(getSessionState, (state: SessionState)=>{
  if(state.selected_session_id == undefined){
    return undefined;
  }
  return state.entities[state.selected_session_id];
})

